<style scoped>
  .uploader-btn {
    display: inline-block;
    position: relative;
    padding: 4px 8px;
    font-size: 100%;
    line-height: 1.4;
    color: #fff !important;
    border: 1px solid #2d8cf0 !important;
    cursor: pointer;
    border-radius: 2px;
    background: none;
    outline: none;
    background-color: #2d8cf0 !important;
    margin: 20px 0;
  }
  p.info{
    margin-top: 10px;
  }
  p.info span{
    color: #e4393c;
  }
</style>
<template>
  <div>
    <Modal title="新增课前预习" v-model="visible" width="1000px" @on-ok="saveData">
      <Form ref="previewForm" class="form"
            :model="formData" :rules="previewRule"
            :label-width="80">
        <Row>
          <Col :span="6">
            <Form-item label="教材版本" prop="version">
              <Select :transfer="true" v-model.number="formData.version" clearable @on-change="onVersionChange">
                <Option v-for="item in $constant.materialVersions" :key="item.code" :value="item.code">{{item.text}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="选择开始Level" prop="levelId" :label-width="100">
              <Select :transfer="true" v-model="formData.levelId" clearable filterable @on-change="onLevelChange">
                <Option v-for="item in levels" :key="item.id" :value="item.id">{{item.title}}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="选择对应课程" :label-width="100">
              <Select :transfer="true" v-model="formData.lessonId" clearable filterable>
                <Option v-for="item in lessons" :key="item.id" :value="item.id">{{item.title}}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="8">
            <Form-item label="标题" prop="title">
              <Input v-model="formData.title"/>
            </Form-item>
          </Col>
          <Col :span="5">
            <Form-item label="状态" prop="status">
              <Select :transfer="true" v-model.number="formData.status" clearable>
                <Option value="-1">禁用</Option>
                <Option value="0">未启用</Option>
                <Option value="1">启用</Option>
                <Option value="2">预览</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div>
      <uploader @file-success="uploadSucess" :options="options" class="uploader-example">
        <uploader-unsupport></uploader-unsupport>
        <uploader-drop>
          <p class="info">上传本地课前预习<span>(注意将主页面改为index.html)</span></p>
          <uploader-btn :directory="true">选择一个文件夹</uploader-btn>
        </uploader-drop>
        <uploader-list></uploader-list>
      </uploader>
      </div>
      <div slot="footer">
        <Button type="text" size="large" @click="visible=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingInsert" @click="saveData">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>

  export default {
    components: {
    },
    name: 'NativeLessonPreviewInsertModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      lessonId: {
        type: Number,
        default: null
      },
      successCallback: {
        type: Function
      }
    },
    data () {
      return {
        id: null,
        levels: [],
        lessons: [],
        headers: {},
        uploadType: '',
        loadingInsert: false,
        acceptType: '',
        formData: {
          indexUrl: '',
          title: '',
          lessonId: null,
          status: '',
          version: null,
          levelId: '',
        },
        options: {
          target: this.$appConfig.baseUrl + '/upload/folderUpload',
          testChunks: false,
          headers: {
            token: this.$store.get('token')
          },
        },
        visible: this.value,
        insertUserParam: {
          regType: '',
        },
        previewRule: {
          title: [
            { type: 'string', required: true, message: '标题不能为空', trigger: 'blur' },
          ],
          version: [
            { type: 'integer', required: true, message: '请选择教材版本', trigger: 'blur' }
          ],
          content: [
            { type: 'string', required: true, message: '内容不能为空', trigger: 'blur' },
          ],
          levelId: [
            { type: 'integer', required: true, message: '请选择对应等级', trigger: 'blur' }
          ],
          status: [
            { type: 'integer', required: true, message: '请选择状态', trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      uploadSucess (rootFile, file, message, chunk) {
        if (file.file.name === 'index.html') {
          this.formData.indexUrl = file.relativePath
        }
      },
      onVersionChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLevel/listByCondition?materialVersion=' + val).then(function (res) {
            if (res.data) {
              self.levels = res.data
            }
          })
        }
      },
      onLevelChange (val) {
        let self = this
        if (val) {
          self.levelId = val
          self.$http.get('/bookMaterialLessons/listByCondition?levelId=' + val).then(function (res) {
            if (res.data) {
              self.lessons = res.data
            }
          })
        }
      },
      saveData () {
        let self = this
        self.loadingInsert = true
        self.$refs.previewForm.validate((valid) => {
          if (!valid) {
            self.$Message.warning('信息输入错误!')
            self.loadingInsert = false
            return
          }
        })
        if (!this.formData.indexUrl) {
          self.$Message.error('无法获取到index.html的路径')
          self.loadingInsert = false
          return
        }
        self.$http.post('/lessonPreview/insert', this.formData).then(function (res) {
          if (res.data > 0) {
            self.$Message.success('新增成功!')
            self.loadingInsert = false
            self.visible = false
            self.successCallback()
          }
        }).catch(function (e) {
          self.loadingInsert = false
        })
      },
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        this.levels = []
        this.lessons = []
        this.formData = {
          content: '',
          title: '',
          lessonId: null,
          status: '',
          version: null,
          levelId: '',
        }
        if (!val) {
          this.$emit('on-close', val)
        }
      },
      lessonId (val) {
        if (val) {
          this.id = val
        }
      }
    },
    mounted () {
    },
    created: function () {
    }
  }
</script>



// WEBPACK FOOTER //
// NativeLessonPreviewInsertModal.vue?2e663fdc